import { GET_PURCHASE_DATA, LOAD_MORE_PURCHASE_DATA } from "../types";
import axios from "axios";
import { firebase } from "../../../firebase/initFirebase";
import moment from "moment";
import { store } from "../../store";
import { message } from "antd";

export const getPurchaseData = (props) => {
  return async (dispatch) => {
    const {
      packageStatus,
      start_date, // e.g. "2025-04-01"
      end_date, // e.g. "2025-04-20"
    } = props;

    const Firestore = firebase.firestore();
    let dataRef = Firestore.collection("purchaseorders");

    // --- add date‐range filters ---
    if (start_date) {
      dataRef = dataRef.where("created_at", ">=", start_date);
    }
    if (end_date) {
      dataRef = dataRef.where("created_at", "<=", end_date);
    }

    // --- existing filters ---
    if (packageStatus) {
      dataRef = dataRef.where("status", "==", packageStatus);
    }

    // you must order by the same field you use in range filters
    dataRef = dataRef.orderBy("created_at", "desc").limit(100);

    const snap = await dataRef.get();
    const docs = snap.docs;
    const lastVisible = docs[docs.length - 1] || null;

    const dataArray = docs.map((doc) => ({
      key: doc.id,
      id: doc.id,
      ...doc.data(),
    }));

    dispatch({
      type: GET_PURCHASE_DATA,
      payload: { dataArray, lastVisible, currentProps: props },
    });
  };
};

export const loadMorePurchaseData = () => {
  return async (dispatch) => {
    const reduxState = store.getState();
    const { packageStatus, start_date, end_date, searchText } =
      reduxState.packages.currentProps || {};
    const currentLastItem = reduxState.packages.lastVisible;
    const Firestore = firebase.firestore();
    let dataRef = Firestore.collection("purchaseorders");

    // same date‐range filters
    if (start_date) {
      dataRef = dataRef.where("created_at", ">=", start_date);
    }
    if (end_date) {
      dataRef = dataRef.where("created_at", "<=", end_date);
    }

    // status filter
    if (packageStatus) {
      dataRef = dataRef.where("status", "==", packageStatus);
    }

    // for pagination
    dataRef = dataRef
      .orderBy("created_at", "desc")
      .startAfter(currentLastItem)
      .limit(100);

    // optional text‐search on `name`
    if (searchText) {
      dataRef = dataRef
        .where("name", ">=", searchText)
        .where("name", "<=", searchText + "\uf8ff");
    }

    const snap = await dataRef.get();
    const docs = snap.docs;
    if (!docs.length) {
      message.error("No more requests to load");
      return;
    }

    const lastVisible = docs[docs.length - 1];
    const dataArray = docs.map((doc) => ({
      key: doc.id,
      id: doc.id,
      ...doc.data(),
    }));

    // avoid duplicate page
    if (lastVisible.id !== currentLastItem.id) {
      message.info("Retrieved more");
      dispatch({
        type: LOAD_MORE_PURCHASE_DATA,
        payload: { dataArray, lastVisible },
      });
    } else {
      message.error("No more requests to load");
    }
  };
};

export const setPurchaseOrder = (currentPO) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var orderRef = Firestore.collection("purchaseorders").doc();

    var setpurchase = await orderRef.set(currentPO, { merge: true });
    return orderRef.id;
  };
};

export const updatePurchaseOrder = (currentPO) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var orderRef = Firestore.collection("purchaseorders").doc(currentPO.id);

    console.log(currentPO);
    var setpurchase = await orderRef.set(currentPO, { merge: true });
    return "hi";
  };
};

export const setSalesOrderPO = (currentPO, currentPOID) => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var Firestore = firebase.firestore();
    var orderRef = Firestore.collection("purchaseorders").doc();

    await Promise.all(
      currentPO.package_list.map(async (itemx) => {
        // preexisting_request
        console.log(itemx);
        var packageRef = Firestore.collection("packages").doc(itemx.id);
        var changesale = await packageRef.set(
          { purchase_request: currentPOID },
          { merge: true }
        );
      })
    );
  };
};

export const attachPurchaseItemSource = (items) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();

    var newItems = [];

    await Promise.all(
      items.map(async (itemx) => {
        var productRef = Firestore.collection("products").doc(itemx.product);
        var documentSnapshots3 = await productRef.get();
        var prodData = documentSnapshots3.data();

        var newOrder = {
          ...itemx,
          ...prodData,
        };
        if (itemx.updated_at < prodData.updated_at) {
          newOrder["cost_peso_new"] = prodData.cost_peso;
        } else if (
          newOrder.cost_peso_new == 0 ||
          newOrder.cost_peso_new == undefined
        ) {
          newOrder["cost_peso_new"] = prodData.cost_peso;
        }

        newItems.push(newOrder);
      })
    );

    return newItems;
  };
};

export const getCurrentItemPrice = (productID) => {
  return async (dispatch) => {
    var Firestore = firebase.firestore();

    var cpeso = 0;

    var productRef = Firestore.collection("products").doc(productID);
    var documentSnapshots3 = await productRef.get();
    var prodData = documentSnapshots3.data();
    // console.log(prodData)
    if (prodData.cost_peso) {
      cpeso = prodData.cost_peso;
    }

    return cpeso;
  };
};

export const backtoapprovePurchase = (id) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("purchaseorders");
    var data = {
      back_to_approved_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      back_to_approved_by: userID,
      back_to_approved_by_name: userName,
      status: "toApprove",
    };
    return dataRef.doc(id).update(data, { merge: true });
  };
};

export const approvePurchase = (id, items) => {
  return (dispatch) => {
    var reduxState = store.getState();
    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("purchaseorders");
    var data = {
      approved_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      approved_by: userID,
      approved_by_name: userName,
      status: "approved",
      items: items,
    };
    return dataRef.doc(id).update(data, { merge: true });
  };
};

export const completePurchase = (purchase) => {
  return async (dispatch) => {
    var reduxState = store.getState();

    var userID = reduxState.auth.user.id;
    var userName = reduxState.auth.user.name;
    var userLocation = reduxState.auth.user.branch;
    var userLocationName = reduxState.auth.user.branch_name;

    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection("purchaseorders");
    var data = {
      completed_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      completed_by: userID,
      completed_by_name: userName,
      status: "completed",
    };
    var updatestep = await dataRef
      .doc(purchase.id)
      .update(data, { merge: true });
    var pitems = purchase.items;
    var prodRef = Firestore.collection("products");
    var inventoryRef = Firestore.collection("inventory");
    await Promise.all(
      pitems.map(async (itemx) => {
        // console.log(itemx)
        // getInventory
        var inventoryID = `${userLocation}_${itemx.product}`;
        var inventorySnap = await inventoryRef.doc(inventoryID).get();
        var inventoryItem = inventorySnap.data();
        var tobuycomp = itemx.actual ?? itemx.tobuy;
        var newquantity =
          parseFloat(inventoryItem.quantity) + parseFloat(tobuycomp);
        var newpesocost = itemx.cost_peso_new;

        var prodData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          updated_by: userID,
          updated_name: userName,
        };

        var InventoryData = {
          updated_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          updated_by: userID,
          updated_name: userName,
          reason: "bought",
        };

        var inventoryLogForm = {
          created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
          reason: "bought",
          created_by: userID,
          created_name: userName,
          purchase_id: purchase.id,
        };

        var pricelog = {
          created_by: userID,
          created_name: userName,
          created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
        };

        prodData[`${userLocation}_count`] = parseFloat(newquantity);
        if (newpesocost && newpesocost > 0) {
          prodData[`cost_peso`] = parseFloat(newpesocost);

          pricelog[`cost_peso`] = parseFloat(newpesocost);
        }

        InventoryData["quantity"] = parseFloat(newquantity);
        inventoryLogForm["quantity"] = parseFloat(newquantity);

        // console.log(inventoryItem)

        // set inventory and log
        // Set product price and inventory
        // log price

        var productChange = await prodRef
          .doc(itemx.product)
          .set(prodData, { merge: true });
        var inventoryChange = await inventoryRef
          .doc(inventoryID)
          .set(InventoryData, { merge: true });
        var inventoryLogMake = await inventoryRef
          .doc(inventoryID)
          .collection("inventory_log")
          .doc()
          .set(inventoryLogForm);

        var priceLogMake = await prodRef
          .doc(itemx.product)
          .collection("price_history")
          .doc()
          .set(pricelog);
      })
    );

    return "hi";
  };
};
